<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3" outlined style="overflow: auto">
            <v-row no-gutters align="center" class="pa-5 pt-0">
                <v-col cols="auto">
                    <v-img
                        src="@/assets/catalog-categories.png"
                        width="60"
                        height="60"
                    ></v-img>
                </v-col>

                <v-col cols="7" class="pl-5">
                    <h4 v-text="translations.title[lang]"></h4>
                    <div
                        style="font-size: 0.875rem"
                        class="font-weight-medium mt-1"
                    >
                        {{ translations.info[lang] }}
                        <router-link
                            class="blue--text ml-1"
                            v-text="translations.giftCatalog[lang]"
                            :to="`/${lang}/loyaltyPanel/catalog/gift-catalog?page=1`"
                        ></router-link>
                    </div>
                </v-col>
            </v-row>

            <v-toolbar flat>
                <v-btn
                    v-if="getPermission('gift_categories.create')"
                    color="secondary"
                    class="text-capitalize d-flex mx-auto mx-sm-0"
                    depressed
                    v-text="translations.addCategory[lang]"
                    @click="addItem"
                ></v-btn>

                <v-spacer></v-spacer>

                <v-col cols="12" sm="4" class="pa-0">
                    <b-search-field v-model.lazy="searchKey"></b-search-field>
                </v-col>
            </v-toolbar>

            <v-sheet min-width="1300">
                <v-data-table
                    :headers="headers"
                    :items="filterItems"
                    :footer-props="{
                        itemsPerPageOptions: [12],
                        showCurrentPage: true,
                        pageText: `${page * 12 - 11}-${
                            page * 12 <= serverItemsLength
                                ? page * 12
                                : serverItemsLength
                        } ${
                            translations.paginationText[lang]
                        } ${serverItemsLength}`,
                    }"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :loading="loading"
                    class="b-outlined"
                >
                    <template v-slot:item.image="{ item }">
                        <v-img
                            :src="item.image"
                            width="70"
                            v-if="item.image"
                        ></v-img>
                        <div v-else>-</div>
                    </template>

                    <template v-if="getPermission('gift_categories.update')" v-slot:item.actions="{ item }">
                        <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                
                                    color="yellow darken-3"
                                    icon
                                    v-on="on"
                                    @click="editItem(item)"
                                >
                                    <v-icon
                                        v-text="icons.mdiPencilOutline"
                                    ></v-icon>
                                </v-btn>
                            </template>

                            <span
                                class="font-weight-bold"
                                v-text="translations.update[lang]"
                            ></span>
                        </v-tooltip>

                        <v-tooltip v-if="getPermission('gift_categories.delete')" color="secondary" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color="red"
                                    icon
                                    v-on="on"
                                    @click="
                                        () => {
                                            gift = item;
                                            deleteDialog = true;
                                        }
                                    "
                                >
                                    <v-icon v-text="icons.mdiClose"></v-icon>
                                </v-btn>
                            </template>

                            <span
                                class="font-weight-bold"
                                v-text="translations.delete[lang]"
                            ></span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-sheet>

            <v-dialog v-model="dialog" max-width="500" scrollable>
                <CategoryForm
                    @back="dialog = false"
                    :item="newitem"
                    :mode="mode"
                />
            </v-dialog>

            <v-dialog  v-model="deleteDialog" max-width="500">
                <b-card
                    :disabled="!getPermission('gift_categories.delete')"
                    type="delete"
                    title="Delete Category"
                    :submit-text="{ el: '', en: 'delete', it: '' }"
                    :loading="loading"
                    :error-message="errorMessage"
                    @cancel="deleteDialog = false"
                    @submit="getPermission('gift_categories.delete')&&deleteItem(gift.gift_category_id)"
                >
                    <div class="subtitle-1 font-weight-medium pt-2 px-2">
                        Are you sure you want to delete
                        <span
                            class="font-weight-bold text--primary"
                            v-if="gift && gift.name"
                            >{{ gift.name[lang] }}</span
                        >?
                    </div>
                </b-card>
            </v-dialog>
        </v-sheet>
    </v-container>
</template>

<script>
import { mdiPencilOutline, mdiClose } from "@mdi/js";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";

import CategoryForm from "@/components/loyaltyPanel/catalogCategories/CategoryForm.vue";
import translations from "@/utils/translations/loyaltyPanel/catalogCategories";

export default {
    name: "CatalogCategories",

    components: { CategoryForm },

    mixins: [translations],

    data() {
        return {
            icons: { mdiPencilOutline, mdiClose },
            newitem: {},
            mode: 'create',
            itemsPerPageOptions: [10, 25, 50, 100],
            dialog: false,
            searchKey: "",
            page: +this.$route.query.page,
        };
    },
    mounted() {
        this.fetchGiftCategories(this.query);
    },
    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapGetters({
            getGiftCategories: "loyaltyPanel/giftCategories/getGiftCategories",
            getDeleteDialog: "loyaltyPanel/giftCategories/getDeleteDialog",
            getGift: "loyaltyPanel/giftCategories/getGift",
        }),
        lang() {
            return this.$route.params.lang;
        },
        items() {
            let items = [];
            for (let category of this.getGiftCategories) {
                items.push({
                    gift_category_id: category.gift_category_id,
                    name: category.name,
                    nameToShow: category.name[this.lang],
                    text_color: category.text_color,
                    bg_color: category.bg_color,
                    image: category.image,
                    upload: null,
                });
            }
            return items;
        },
        filterItems() {
            if (this.searchKey) {
                return this.items.filter((item) => {
                    return this.searchKey
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.name[this.lang]
                                    .toLowerCase()
                                    .includes(v) ||
                                item.text_color.toLowerCase().includes(v) ||
                                item.bg_color.toLowerCase().includes(v)
                        );
                });
            }
            return this.items;
        },
        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
        headers() {
            return [
                {
                    text: this.translations.imageCategory[this.lang],
                    value: "image",
                },
                {
                    text: this.translations.categoryName[this.lang],
                    value: "nameToShow",
                },
                {
                    text: this.translations.fontColor[this.lang],
                    value: "text_color",
                },
                {
                    text: this.translations.backgroundColor[this.lang],
                    value: "bg_color",
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                },
            ];
        },
        gift: {
            get() {
                return this.getGift;
            },

            set(val) {
                this.setGiftData(val);
            },
        },
        deleteDialog: {
            get() {
                return this.getDeleteDialog;
            },

            set(val) {
                this.setDeleteDialog(val);
            },
        },
    },

    methods: {
        ...mapMutations("loyaltyPanel/giftCategories", [
            "setDeleteDialog",
            "setGiftData",
        ]),
        ...mapActions(["getPermission"]),
        ...mapActions({
            fetchGiftCategories:
                "loyaltyPanel/giftCategories/fetchGiftCategories",
            deleteItem: "loyaltyPanel/giftCategories/delete",
        }),
        addItem() {
            this.dialog = true;
            this.mode = 'create';
            this.newitem = {
                name: {
                    el: "",
                    en: "",
                    it: "",
                },
                text_color: "#000000",
                bg_color: "#FFFFFF",
                image: "",
                upload: null,
                gift_category_id: undefined,
            };
        },
        editItem(item) {
            this.mode = 'update';
            this.dialog = true;
            this.newitem = item;
        },
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.fetchGiftCategories(this.query);
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },
};
</script>

<style scoped>
.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
